import React from "react"
import JSON5 from "json5"
import {useSelector} from "react-redux"
import {PopupButton} from "react-calendly"
import makeStyles from "@material-ui/core/styles/makeStyles"

const useStyles = makeStyles(theme => ({
    buttonWrapper: {
        position: "fixed",
        bottom: "30px",
        right: "30px",
        zIndex: 1000,
        "& button": {
            width: "auto",
            height: "45px",
            borderRadius: "25px",
            letterSpacing: '0.1em',
            padding: "0 15px",
            fontSize: "14px",
            fontWeight: 700,
            backgroundColor: theme.palette.primary.main || "#0078FF",
            color: theme.palette.getContrastText(theme.palette.primary.main || "#0078FF"),
            border: "none",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
            cursor: "pointer"
        },
        "& button:hover": {
            backgroundColor: theme.palette.primary.dark || "#005AC1",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)"
        }
    }
}))

const CalendlyMeetingButton = () => {
    const classes = useStyles()

    const {authUser} = useSelector(({auth}) => auth)
    const {settings} = useSelector(({appSettings}) => appSettings)

    const [localization, setLocalization] = React.useState(null)
    const [displayButton, setDisplayButton] = React.useState(false)
    const [calendlyMeetingURL, setCalendlyMeetingURL] = React.useState("")

    React.useEffect(() => {
        if (authUser && "settings" in authUser) {
            let settings = JSON5.parse(authUser.settings)
            if ("localisation" in settings)
                setLocalization(settings["localisation"])

            if ("calendly" in settings)
                setCalendlyMeetingURL(settings["calendly"])
        }
    }, [authUser])

    React.useEffect(() => {
        if (settings) {
            let GroupList = settings?.GroupList
            if (GroupList) {
                let group = GroupList.find((item) => item["group_id"] === "grp_1")
                if (group) {
                    let group_items = group?.group_items
                    if (group_items) {
                        let pro103 = group_items.find((item) => item["item_id"] === "pro_103")
                        if (pro103) {
                            setDisplayButton(pro103["item_default"] === "Y")
                        }
                    }
                }
            }
        }
    }, [settings])

    return (
        <>
            {
                displayButton === true && calendlyMeetingURL ?
                    <div className={classes.buttonWrapper}>
                        <PopupButton
                            url={calendlyMeetingURL}
                            rootElement={document.getElementById("root")}
                            text={localization ? localization["tra_310"] : ""}
                        />
                    </div>
                    : null
            }
        </>
    )
}

export default CalendlyMeetingButton
